import Vue from 'vue';
import 'element-ui/lib/theme-chalk/index.css';
import {
    Button,
    Loading,
    Message,
    Input,
    Select,
    Option,
    DatePicker,
    Progress,
    MessageBox,
    Pagination,
    Upload,
    Cascader,
    Carousel,
    CarouselItem
} from "element-ui";

Vue.prototype.$message = Message;
Vue.prototype.$MessageBox = MessageBox;

Vue.use(Button);
Vue.use(Loading);
Vue.use(Pagination);
Vue.use(Progress);
Vue.use(Select);
Vue.use(Option);
Vue.use(Input);
Vue.use(DatePicker);
Vue.use(Upload);
Vue.use(Cascader);
Vue.use(Carousel);
Vue.use(CarouselItem);
